// License system removed for debugging

/* Galerie produit : rattache les infographies de notes à leur parfum.
   Reconnues par le nom du fichier (jovieza-notes-<parfum>) ou par l'alt "<Parfum> scent notes...". */
(function(){
  function slug(t){return String(t).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
  function run(){
    var dataEl=document.querySelector('[data-pdp-json]'); if(!dataEl) return;
    var data; try{data=JSON.parse(dataEl.textContent);}catch(e){return;}
    var opts=data.opts||[]; if(!opts.length) return;
    var root=dataEl.closest('[class*="jzw-pdp-"]')||document;
    var track=root.querySelector('[data-track]'); if(!track) return;
    var slides=[].slice.call(track.children),
        ths=[].slice.call(root.querySelectorAll('[data-th]')),
        dots=[].slice.call(root.querySelectorAll('.jw-gal__dots i'));
    var tagged=[];
    slides.forEach(function(s,i){
      if(s.hasAttribute('data-vm')) return;
      var img=s.querySelector('img'); if(!img) return;
      var alt=img.getAttribute('alt')||'', src=img.getAttribute('src')||'';
      for(var k=0;k<opts.length;k++){
        if(src.indexOf('jovieza-notes-'+slug(opts[k].t)+'.')>-1||alt.indexOf(opts[k].t+' scent notes')===0){
          [s,ths[i],dots[i]].forEach(function(el){if(el){el.setAttribute('data-vm',String(opts[k].id));tagged.push(el);}});
          break;
        }
      }
    });
    if(!tagged.length) return;
    var on=slides.filter(function(s){return s.getAttribute('data-vm')&&!s.hidden;})[0];
    var cur=on?on.getAttribute('data-vm'):String(data.current||opts[0].id);
    tagged.forEach(function(el){el.hidden=el.getAttribute('data-vm')!==cur;});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();
